import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
class NoMatch extends React.Component{
  render(){
    return(
      <Jumbotron>
        <h1>Page non trouvée (404)</h1>
        <p>
          Nous n'avons pas trouvé ce que vous recherchiez.
        </p>
        <p>
          Il semble que vous ayez suivi un lien rompu ou que vous ayez entré une URL qui n'existe pas sur ce site.
        </p>
        <p>

        <Link to="/">  <Button variant="primary">Retour sur notre site</Button></Link>
        </p>
      </Jumbotron>

    );
  }
}

export default NoMatch;
